package com.eladfinish.bible.contest.screens.search.usecases.number

import com.eladfinish.bible.contest.di.config.DebugInfo
import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

data class ParsedHighlightedContent(
    val text: String,
    val highlightedRanges: ImmutableList<IntRange>,
)

class ParseBackendHighlightedContentUseCase(
    private val debugInfo: DebugInfo,
) {

    operator fun invoke(
        content: String,
    ): ParsedHighlightedContent {
        val highlightedRanges = mutableListOf<IntRange>()
        val output = StringBuilder()

        var sourceIndex = 0
        var outputIndex = 0

        while (sourceIndex < content.length) {
            when {
                content.startsWith(OPEN_BOLD_TAG, sourceIndex) -> {
                    sourceIndex += OPEN_BOLD_TAG.length

                    val highlightStart = outputIndex

                    while (
                        sourceIndex < content.length &&
                        !content.startsWith(CLOSE_BOLD_TAG, sourceIndex)
                    ) {
                        output.append(content[sourceIndex])
                        sourceIndex++
                        outputIndex++
                    }

                    val highlightEndExclusive = outputIndex

                    if (highlightStart < highlightEndExclusive) {
                        @Suppress("EmptyRange")
                        highlightedRanges += highlightStart until highlightEndExclusive
                    }

                    if (content.startsWith(CLOSE_BOLD_TAG, sourceIndex)) {
                        sourceIndex += CLOSE_BOLD_TAG.length
                    }
                }

                content.startsWith(CLOSE_BOLD_TAG, sourceIndex) -> {
                    sourceIndex += CLOSE_BOLD_TAG.length
                }

                else -> {
                    output.append(content[sourceIndex])
                    sourceIndex++
                    outputIndex++
                }
            }
        }

        if (debugInfo.isDebugMode) {
            Napier.d(
                message = "Number search parsed highlights: $highlightedRanges",
                tag = "SearchNumberUseCase",
            )
        }

        return ParsedHighlightedContent(
            text = output.toString(),
            highlightedRanges = highlightedRanges.toImmutableList(),
        )
    }


    private companion object {
        const val OPEN_BOLD_TAG = "<b>"
        const val CLOSE_BOLD_TAG = "</b>"
    }
}
